// Deterministic per-tag color styles
// - Year tags (4-digit) use a shared medium-dark gray
// - Other tags: medium-dark color derived from a hash of the tag string

function stringHashHue(str) {
	let hash = 0 >>> 0;
	for (let i = 0; i < str.length; i++) {
		hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
	}
	return hash % 360; // 0-359 hue
}

// Optional overrides for specific tag labels -> {h, s, l} object
// Edit or extend this map to lock specific tags to fixed colors.
// Keys must match the tag labels exactly as used in data.
// h: hue (0-359), s: saturation (0-100), l: lightness (0-100)
const defaultSaturation = 60;
const defaultLightness = 25;
const TAG_COLOR_MAP = {
	// Examples (tuned for medium-dark palettes)
	"Full Game": { h: 130, s: defaultSaturation, l: defaultLightness },
	"Prototype": { h: 30, s: defaultSaturation, l: defaultLightness },
	"Game Jam": { h: 358, s: defaultSaturation, l: defaultLightness },
	"Work Project": { h: 265, s: defaultSaturation, l: defaultLightness },
	"Tabletop Tool": { h: 210, s: defaultSaturation, l: defaultLightness },
	"C#": { h: 200, s: 255, l: defaultLightness },
	"Unity Engine": { h: 0, s: 0, l: defaultLightness * 0.8 },
	"Unity Relay": { h: 30, s: 80, l: defaultLightness },
	"Game Design": { h: 45, s: 100, l: defaultLightness },
	"Level Design": { h: 35, s: 255, l: defaultLightness },
	"Local Multiplayer": { h: 300, s: defaultSaturation * 0.5, l: 40 },
	"Solo Development": { h: 330, s: defaultSaturation, l: defaultLightness * 1.1 },
	"2D Physics": { h: 90, s: defaultSaturation * 0.75, l: defaultLightness * 1.2 },
	"3D Physics": { h: 90, s: defaultSaturation * 0.75, l: defaultLightness * 1.2 },
};

function getColorForTag(label) {
	if (Object.prototype.hasOwnProperty.call(TAG_COLOR_MAP, label)) {
		return TAG_COLOR_MAP[label];
	}
	const isYear = /^\d{4}$/.test(label);
	const containsHours = /hours?/i.test(label);
	if (isYear || containsHours) {
		return { h: 0, s: 0, l: 30 }; // medium-dark gray
	}
	// Default: hash-based hue with standard saturation/lightness
	return {
		h: stringHashHue(label),
		s: defaultSaturation,
		l: defaultLightness,
	};
}

export function getTagStyle(tag) {
	const { h, s, l } = getColorForTag(String(tag || "").trim());
	const bg = `hsl(${h}, ${s}%, ${l}%)`;
	const border = `hsl(${h}, ${Math.min(s + 5, 100)}%, ${Math.max(l - 15, 0)}%)`;
	return {
		backgroundColor: bg,
		borderColor: border,
		color: "#fff",
	};
}
